import { AxiosResponse } from 'axios';
import { ApiClient } from '../ApiClient';

export interface IBlipConfig {
  channel_code: string;
  blip_user_id: number;
  blip_endpoint: string;
  blip_account_id: number;
  blip_user_token: string;
}

export function getBlipConfig(
  accountDomain: string,
  channelId: number,
): Promise<AxiosResponse<IBlipConfig>> {
  return ApiClient.get(`/accounts/${accountDomain}/channels/${channelId}/blip`);
}
